/** @jsx builderX.jsx */

import {builderX, Image, Sprite, Text} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite position={[0, 0]} name='win'>
        <Image name='bg' src='win_bg' />
        <Text
            position={[52, 75]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 170,
                fontStyle: 'normal',
                fill: '#FFFFFF',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='fieldText'
            localeTextID=''
            text='$24000.00'
        />
        <Text
            position={[425, 267]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 40,
                fontStyle: 'normal',
                fill: '#FFD200',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={254}
            name='label'
            localeTextID=''
            text='WIN'
        />
    </Sprite>
);
